<template>
  <div class="layout is-relative">

    <section class="hero is-fullheight px-4 py-4">
      <WHeader/>
      <hr>
      <div v-if="!downScheme && hallId" id="w-title-scene"
           class="has-text-centered has-text-white-bis title-scene is-size-7">Сцена
      </div>
      <main class="main is-relative is-clipped" id="main">
        <transition name="fade">
          <router-view></router-view>
        </transition>
        <CubeLoader :show="isShowLoader"/>
      </main>

      <div v-if="downScheme && hallId" id="w-title-scene"
           class="has-text-centered has-text-white-bis title-scene is-size-7">Сцена
      </div>
      <!--            <transition-group name="fade">-->
      <!--                <template v-if="hallPlan.length>1">-->
      <!--                  -->
      <!--                </template>-->
      <!--                <template v-else>-->

      <!--                </template>-->
      <!--                &lt;!&ndash;                <router-view></router-view>&ndash;&gt;-->
      <!--            </transition-group>-->
      <hr>
      <WFooter/>
    </section>
    <w-tooltip/>
  </div>
</template>

<script>
import CubeLoader from "./CubeLoader";
import WHeader from "./WHeader";
import WFooter from "./WFooter";
import WTooltip from "./WTooltip";
import {mapState} from "vuex";

export default {
  name: "Container",
  components: {
    CubeLoader,
    WHeader,
    WFooter,
    WTooltip
  },
  data () {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      isShowLoader: true,
      hallId: null
    }
  },
  computed: {
    ...mapState({
      performanceID: state => state.performanceID,
      counters: state => state.counters,
    }),
    downScheme () {
      const halls = [
        201,
        501,
        31343,
      ]

      return halls.includes(this.hallId);

    },
  },
  mounted () {
    this.getData(this.performanceID)
  },
  methods: {
    mobile () {
      return this.windowHeight < 768 && this.windowWidth < 1024;
    },
    getData (performanceID) {
      let vm = this;
      Promise.all([window.api.getPerformanceCard(performanceID), window.api.getPerformanceHallPlan(performanceID), window.api.getCouponsInfo(performanceID)])
          .then(function (results) {
            console.log('Start result',results)
            if (results[0].data.data.length === 0) {
              vm.showError()
            }
            const performanceCard = results[0].data.data[0];
            const hallPlan = results[1].data.data;

            vm.hallId = results[0].data.data[0]['hall_id']
            if ((results[0].status === 200) && (results[1].status === 200)) {
              vm.$store.commit('setEventCard', performanceCard);
              vm.$store.commit('setHallPlan', hallPlan);
              vm.$store.commit('setHasCoupons', results[2].data.data.has_coupons);
              if (!vm.mobile()) {
                vm.$router.push({
                  name: 'Section',
                  params: { section_id: 0 }
                })
              } else {
                vm.$store.commit('setMobile', true);
                if ((vm.$route.name === 'Home') && (performanceCard.is_navigated)) {
                  vm.$router.push({ name: 'Sections' })
                } else if ((vm.$route.name !== 'Section') && (!performanceCard.is_navigated)) {
                  vm.$router.push({
                    name: 'Section',
                    params: { section_id: 0 }
                  })
                }
              }
              // vm.$nextTick(function () {
              //   vm.isShowLoader = false;
              // })
            } else {
              vm.$nextTick(function () {
                vm.isShowLoader = false;
              })
              vm.showError()
            }
          })
          .catch((e) => {
            console.log('Catch',e)
            this.$router.push({ name: 'Error' });
          });
    },
    showError () {
      this.$router.push({ name: 'Error' })
    }
  },
  events: {
    showLoader () {
      this.isShowLoader = true;
    },
    hideLoader () {

      this.isShowLoader = false;
    },
    maxTickets () {
      // Показываем уведомление о том, что в корзине уже находится максимальном количестве билетов
      this.$buefy.toast.open({
        duration: 5000,
        message: `В корзину нельзя положить более 9 билетов`,
        position: 'is-top',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style scoped>
.title-scene {
  margin-top: -0.75rem;
  padding: 0.5rem;
}
</style>
